import { SWReactCountryIcons } from "@similarweb/icons";
import { CountryFilter } from "app/components/filters-bar/country-filter/CountryFilter";
import { buildDropdownSelectedItemsFromArray } from "app/pages/sales-intelligence/utils/dropdowns";
import {
    StyledCountryButtonDd,
    StyledCountryButtonDDText,
    StyledCountryDDWrapper,
} from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import type TrafficSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSignalFilters";
import filtersService from "app/pages/sales-intelligence/sub-modules/signals/services/ui-signals/traffic/trafficSignalFiltersService";
import type { FC } from "react";
import { useEffect, useMemo } from "react";
import type { ICountryObject } from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import SignalFilterDropdownButton from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/SignalFilterDropdownButton/SignalFilterDropdownButton";

type SignalTrafficCountryFilterProps = {
    filters: Readonly<Partial<TrafficSignalFilters>>;
    allowedCountries: readonly ICountryObject[];
    onFiltersChange(filters: Readonly<Partial<TrafficSignalFilters>>): void;
};

const SignalTrafficCountryFilter: FC<SignalTrafficCountryFilterProps> = ({
    filters,
    allowedCountries,
    onFiltersChange,
}) => {
    useEffect(() => {
        if (!filters.trafficChanges?.country) {
            const countryCode = getDefaultCountry();

            if (countryCode) {
                onFiltersChange(
                    filtersService.getTrafficChannelsFilter(filters, {
                        country: countryCode,
                    }),
                );
            }
        }
    }, []);

    const getDefaultCountry = () => {
        const worldwideCountry = allowedCountries.find((elem) => elem.id === WORLDWIDE_COUNTRY_ID);

        // TODO move default country from the view to respective service
        // + how should we handle case when there are no allowed countries? (ie [])
        return worldwideCountry ? worldwideCountry.id : allowedCountries[0].id;
    };

    const selectedCountry = useMemo(() => {
        const countryCode = getDefaultCountry();
        return (filters.trafficChanges?.country as number) || countryCode;
    }, [filters]);

    const handleCountryChange = (country: ICountryObject | null) => {
        if (country) {
            return onFiltersChange(
                filtersService.getTrafficChannelsFilter(filters, {
                    country: country.id,
                }),
            );
        }
    };

    return (
        <StyledCountryDDWrapper>
            <CountryFilter
                cssClassContainer={"traffic-changes-countries-dd"}
                selectedCountryIds={buildDropdownSelectedItemsFromArray([selectedCountry])}
                dropdownPopupWidth={322}
                // @ts-expect-error
                changeCountry={handleCountryChange}
                height={40}
                // @ts-expect-error
                availableCountries={allowedCountries}
                dropdownPopupPlacement="bottom-left"
                dropdownPopupHeight={210}
                renderButtonComponent={(selectedCountry: ICountryObject) => {
                    return (
                        <SignalFilterDropdownButton
                            id="traffic-signal-country-dd-button"
                            key="button"
                        >
                            {selectedCountry ? <StyledCountryButtonDd>
                                    <SWReactCountryIcons
                                        countryCode={selectedCountry.id}
                                        size={"22px"}
                                    />
                                    <StyledCountryButtonDDText>{selectedCountry.text}</StyledCountryButtonDDText>
                                </StyledCountryButtonDd> : null}
                        </SignalFilterDropdownButton>
                    );
                }}
            />
        </StyledCountryDDWrapper>
    );
};

export default SignalTrafficCountryFilter;
